<p
  class="session-check-info"
  [innerHTML]="'Session ends in {seconds} seconds' | translate: { seconds: '<span>' + seconds() + '</span>' }"
></p>
